export default {"src":"/_next/static/media/disc-wheels.c7eda7ca.svg","height":353,"width":478,"blurWidth":0,"blurHeight":0};